import React, { ComponentProps as CP } from 'react'

import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles'

import config from 'config'
import T from 'components/FormattedMessage'
import Paper from 'components/Paper'
import Button from 'components/Button'
import ProfileLinks from 'components/ProfileLinks'
import PremiumMembership from 'components/PremiumMembership'
import UserInfo from 'components/UserInfo'
import InviteFriendsButton from 'components/InviteFriendsButton'
import MostSelected from 'components/MostSelected'
import VitalStatistics from 'components/VitalStatistics'

import ProfileAutoSub from './components/ProfileAutoSub'
import FacebookButton from './components/FacebookButton'

export interface Props {
  hasActiveMembership: boolean
  userInfo: CP<typeof UserInfo>
  mostSelected: CP<typeof MostSelected>
  vitalStatistics: CP<typeof VitalStatistics>
}

const styles = createStyles({
  fillHeight: {
    height: '100%'
  }
})

type InjectedProps = Props & WithStyles<typeof styles>

const InfoTab: React.SFC<InjectedProps> = ({
  classes,
  userInfo,
  mostSelected,
  vitalStatistics,
  hasActiveMembership
}) => {
  const { topPlayerScore, topTeamScore } = vitalStatistics
  const { player, team } = mostSelected

  const shouldShowVitalStatistics = !!topPlayerScore && !!topTeamScore
  const shouldShowMostSelectedStatistics = !!player && !!team

  return (
    <Grid direction="column" container>
      <Grid item>
        <UserInfo {...userInfo} />
      </Grid>

      <Grid item>
        <Paper>
          <ProfileAutoSub />
        </Paper>
      </Grid>

      {!hasActiveMembership && !config.IS_STORE_DISABLED && (
        <Grid item>
          <PremiumMembership />
          <Divider />
        </Grid>
      )}

      <Grid item>
        {shouldShowVitalStatistics && <VitalStatistics {...vitalStatistics} />}
        {shouldShowMostSelectedStatistics && <MostSelected {...mostSelected} />}
      </Grid>

      <Grid item>
        <Paper pad="medium">
          <Grid direction="row" spacing={2} container>
            <Grid xs item>
              <InviteFriendsButton className={classes.fillHeight} fullWidth />
            </Grid>
            <Grid xs item>
              <FacebookButton className={classes.fillHeight} fullWidth />
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      <Grid item>
        <ProfileLinks />
      </Grid>

      <Grid item>
        <Paper pad="medium">
          <Button
            fullWidth
            color="secondary"
            variant="contained"
            to="/profile/settings"
          >
            <T id="userprofile_action_editprofile" />
          </Button>
        </Paper>
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(InfoTab)
